import { UserAvatarIcon } from '../../../../../../shared/frontend/components/presentational/userAvatarIcon';

export function LoggedSourceLine(props: any) {
  const loggedSource = props.loggedSource;

  if (!loggedSource.name && !loggedSource.characterName) {
    return <div>Anonymous</div>;
  }

  if (!loggedSource.name) {
    return (
      <div>
        <i>{loggedSource.characterName}</i>
      </div>
    );
  }

  return (
    <div>
      <UserAvatarIcon icon={loggedSource.avatar} size="xx-small" /> <b>{loggedSource.name}</b>
      {loggedSource.characterName && <> ({loggedSource.characterName})</>}
    </div>
  );
}
